<template>
	<div class="box">
		<div class="icon is-medium">
			<template v-if="icon">
				<font-awesome-icon :icon="icon" class="fa-2x" />
			</template>
			<template v-if="emoji">
				<span v-html="emoji"></span>
			</template>
		</div>

		<div class="is-size-3">{{ value }}</div>
		<div class="stat-title">{{ name }}</div>
		<div class="stat-details">{{ description }}</div>
	</div>
</template>

<script>
export default {
	props: ["icon", "emoji", "value", "name", "description"],
}
</script>

<style scoped>
.icon.is-medium span {
	font-size: 2em;
}
</style>